import script from "./InProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./InProgress.vue?vue&type=script&setup=true&lang=js"

import "./InProgress.vue?vue&type=style&index=0&id=2564a0d6&scoped=true&lang=css"

import exportComponent from "/home/xs909715/manage-sys.net/deploy/call-center-fe/production/releases/5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2564a0d6"]])

export default __exports__